import { createRouter, createWebHistory } from 'vue-router'
import signList from '@/views/XiaomiSign.vue'
import activityPage from '@/views/ActivityPage.vue'
import activityXPage from '@/views/ActivityXPage.vue'
import configPage from '@/views/ConfigPage.vue'
import viewPage from '@/views/ViewPage.vue'
import activityPageList from '@/views/AcitivityPageList.vue'
const routes = [
  { path: '/', redirect: '/activity' }, // 默认重定向到 /a
  { path: '/sign', component: signList },
  { path: '/activity', component: activityPage },
  { path: '/x/activity', component: activityXPage },
  { path: '/config', component: configPage },
  { path: '/view', component: viewPage },
  { path: '/pages', component: activityPageList }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
